<mat-form-field class="example-full-width">
  <mat-select [(ngModel)]="linkId" data-id="deeplinks_type" [disabled]="!editMode">
    @for (deeplink of deeplinks; track deeplink) {
      <mat-option
        [attr.data-id]="'option_' + deeplink.name"
        [value]="deeplink.id"
        (onSelectionChange)="onDeeplinkChange(deeplink, $event, undefined)">
        {{ deeplink.name }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

@if (selected && hasFormData) {
  <app-nested-panel-form-field
    [fields]="fields"
    [canAdd]="false"
    [editMode]="editMode"
    [fieldConfig]="selectedFieldConfig"
    [(formGroup)]="formGroup"
    [(data)]="linkData"></app-nested-panel-form-field>
}

@if (selected && !hasFormData) {
  <p>No Data required</p>
}
